"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueTypes = exports.typographyFonts = exports.styles = exports.startSiteTime = exports.siteCardGoToKey = exports.rangeCoordinate = exports.packageKey = exports.oneSecondInMS = exports.defaultCoordinate = exports.colors = exports.CheckAccessToSiteKey = void 0;
const packageKey = 'paul_map';
exports.packageKey = packageKey;
const CheckAccessToSiteKey = {
  isApproved: 'isApproved',
  isForbidden: 'isForbidden'
};
exports.CheckAccessToSiteKey = CheckAccessToSiteKey;
const siteCardGoToKey = {
  isApproved: 'isApproved',
  isForbidden: 'isForbidden'
};

/** @todo: colors object should be deleted after installing MUI Theme and refactoring components to use theme colors */
exports.siteCardGoToKey = siteCardGoToKey;
const colors = {
  'main-color-cl-01': '#00205B',
  'main-color-cl-01-hover': '#002B7A',
  'main-color-cl-02': '#2D78C6',
  'main-color-cl-03': '#37AFEB',
  'main-color-cl-04': '#81D1F7',
  'main-color-cl-05': '#BBE9FF',
  'main-color-cl-06': '#E3F7FF',
  'main-color-cl-07': '#F6F8FC',
  'main-color-cl-08': '#FFFFFF',
  'main-color-cl-09': '#F3F3F3',
  'main-color-cl-10': '#212134',
  'main-color-cl-11': '#32324D',
  'main-color-cl-12': '#4A4A6A',
  'main-color-cl-13': '#666687',
  'main-color-cl-14': '#8E8EA9',
  'main-color-cl-15': '#A5A5BA',
  'main-color-cl-16': '#C0C0CF',
  'main-color-cl-17': '#DCDCE4',
  'main-color-cl-18': '#EAEAEF',
  'main-color-cl-19': '#F6F6F9',
  'main-color-cl-20': '#00BC4B',
  'main-color-cl-21': '#D02B20',
  'main-color-cl-22': '#F29D41',
  'main-color-cl-30': '#0000FF',
  'main-color-cl-31': '#1CE783',
  'main-color-cl-32': '#EFEFED',
  'main-color-cl-40': '#E5E5E7',
  'main-color-cl-90': 'rgba(#FF00FF, 0.3)',
  'main-color-cl-91': '#FF00FF',
  'main-color-cl-92': '#FCFCFD',
  'main-color-cl-93': '#FF8000',
  'main-color-cl-94': '#E71D1C',
  'main-color-cl-95': '#101828',
  'main-color-cl-96': '#000033',
  'main-color-cl-97': '#000066',
  'main-color-cl-98': '#475467',
  'main-color-cl-99': '#667085',
  'main-color-cl-100': '#98a2b3'
};

/**
 @todo: styles object should be deleted after installing MUI Theme and refactoring components to use theme colors
 **/
exports.colors = colors;
const styles = {
  transitionType: {
    primary: '.5s ease',
    secondary: '.2s ease'
  },
  boxShadow: {
    primary: '0 5px 15px rgb(0 0 0 / 10%)',
    secondary: '0 4px 10px rgba(0, 0, 0, 0.08)'
  },
  borderRadius: {
    button: '8px',
    input: '8px',
    card: '10px'
  },
  textCrop: function textCrop() {
    let lines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return {
      overflow: "hidden",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: lines
    };
  }
};
exports.styles = styles;
const valueTypes = {
  string: 'string',
  number: 'number'
};

/** @todo move to core */
exports.valueTypes = valueTypes;
const typographyFonts = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'subtitle1',
  subtitle2: 'subtitle2',
  body1: 'body1',
  body2: 'body2',
  button: 'button',
  inherit: 'inherit'
};
exports.typographyFonts = typographyFonts;
const oneSecondInMS = 1000;
exports.oneSecondInMS = oneSecondInMS;
const startSiteTime = 5 * oneSecondInMS;
exports.startSiteTime = startSiteTime;
const rangeCoordinate = {
  minLatitude: -90,
  maxLatitude: 90,
  minLongitude: -180,
  maxLongitude: 180
};
exports.rangeCoordinate = rangeCoordinate;
const defaultCoordinate = {
  latitude: 0,
  longitude: 0
};
exports.defaultCoordinate = defaultCoordinate;